import React, { useContext } from 'react';
import 'twin.macro';
import { UserContext } from '../context/';
import { ModerationWrapper } from './';

export const CommentsWrapper = ({ children }) => {
  const { user } = useContext(UserContext);
  const userCanModerate = user && user.moderate;
  return (
    <>
      {!userCanModerate && <>{children}</>}
      {userCanModerate && (
        <>
          <ModerationWrapper>{children}</ModerationWrapper>
        </>
      )}
    </>
  );
};
